import classNames from "classnames";
import React, { FC } from "react";

import { useScreenMd } from "~/utils";

export const NoContentFound: FC<{ className?: string }> = ({
  children,
  className,
}) => {
  const isDesktop = useScreenMd();

  return (
    <h5
      className={classNames(
        "containerContent text-center w-100 mg-t-2em",
        isDesktop
          ? "w-100 font-variant-big-caps"
          : "w-90 font-variant-small-caps",
        className
      )}
    >
      {children}
    </h5>
  );
};
